import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveExit16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMoveExit16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.738 7.026c0 .331.27.6.6.6h3.879a.6.6 0 0 0 0-1.2h-3.878a.6.6 0 0 0-.6.6m.107 2.405a.6.6 0 0 0 .6.6h2.637a.6.6 0 1 0 0-1.2h-2.638a.6.6 0 0 0-.6.6m-8.517-.94a3.7 3.7 0 0 0 3.695 3.51l.19-.005A3.7 3.7 0 0 0 8.72 8.493l.005-.19A3.7 3.7 0 0 0 5.023 4.6l-.19.005A3.7 3.7 0 0 0 1.323 8.3zm1.195-.19a2.5 2.5 0 1 1 5.002 0 2.5 2.5 0 0 1-5.002 0"
            />
        </svg>
    );
}
export default memo(IconMoveExit16);
